import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	endUserTitle: {
		id: 'backlog.flags.clear-custom-filter-failed.end-user-title',
		defaultMessage: "We couldn't clear your filters",
		description: 'Warning Flag title shown to end user',
	},
	endUserDescription: {
		id: 'backlog.flags.clear-custom-filter-failed.end-user-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Warning flag body shown to end user',
	},
	endUserActionLink: {
		id: 'backlog.flags.clear-custom-filter-failed.end-user-action-link',
		defaultMessage: 'Reload page',
		description: 'Warning flag action link shown to end user',
	},
});
